import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ErrorItemText } from '../ErrorsPresenter/ErrorsPresenter';
import { MoneyCell } from '../MoneyCell/MoneyCell';
import { PhraseTrafficForecast } from '../PhraseTrafficFocast/PhraseTrafficForecast';
import {
    TableColumnAlignType,
    TableData,
    TableDataTheme
} from '../TableData/TableData';
import { TextInputDecorator } from '../TextInputDecorator/TextInputDecorator';

import './TrafaretPhrasePriceEditor.css';
import * as keyset from './TrafaretPhrasePriceEditor.i18n';

const i18n = i18nFactory(keyset);

export interface TrafaretPriceEditorProps {
    error?: ErrorItemText;
    bid?: string;
    trafficVolume?: number;
    amnestyPrice?: number;
    currency: string;
    onBidChange: (val: string) => void;
    onBidBlur: () => void;
    trafficVolumeMaxValue: number;
    trafficVolumeMinValue: number;
    onTrafficVolumeChange: (val: number) => void;
    adjustmentsRateWarning?: string;
}

export class TrafaretPhrasePriceEditor extends React.PureComponent<
    TrafaretPriceEditorProps
> {
    render() {
        const { error } = this.props;

        return (
            <div className={Bem.cls('trafaret-price-editor')}>
                <TableData
                    columns={this.getTrafaretColumns()}
                    theme={TableDataTheme.dark}
                />

                <div className={Bem.cls('trafaret-price-editor', 'error')}>
                    {error}
                </div>

                {this.getWarning()}

                {this.getHint()}
            </div>
        );
    }

    private getTrafaretColumns = () => {
        const {
            trafficVolumeMinValue,
            trafficVolumeMaxValue,
            currency,
            bid = '',
            trafficVolume,
            amnestyPrice,
            error
        } = this.props;

        return [
            {
                width: 110,
                header: i18n('bid'),
                cells: [
                    <TextInputDecorator
                        key={1}
                        text={bid}
                        onChange={this.onBidChange}
                        onBlur={this.onBidBlur}
                        size={'m'}
                        valid={!error}
                        theme={'normal'}
                        view={'classic'}
                    />
                ]
            },
            {
                width: 170,
                header: i18n('bid-forecast'),
                cells: [
                    <PhraseTrafficForecast
                        key={1}
                        value={trafficVolume}
                        minValue={trafficVolumeMinValue}
                        maxValue={trafficVolumeMaxValue}
                        onValueChange={this.onTrafficVolumeChange}
                    />
                ]
            },
            {
                width: 180,
                header: i18n('amnesty-price'),
                align: TableColumnAlignType.right,
                cells: [
                    <MoneyCell key={1} currency={currency} num={amnestyPrice} />
                ]
            }
        ];
    };

    private getWarning = () => {
        const { trafficVolume, error } = this.props;

        if (trafficVolume || error) {
            return null;
        }

        return (
            <div className={Bem.cls('trafaret-price-editor', 'warning')}>
                {i18n('low-shows-warning')}
            </div>
        );
    };

    private getHint = () => {
        const { adjustmentsRateWarning } = this.props;

        if (!adjustmentsRateWarning) {
            return null;
        }

        return (
            <div className={Bem.cls('trafaret-price-editor', 'hint')}>
                {adjustmentsRateWarning}
            </div>
        );
    };

    private onBidChange = (value: string) => {
        this.props.onBidChange(value);
    };

    private onBidBlur = () => {
        this.props.onBidBlur();
    };

    private onTrafficVolumeChange = (value: number) => {
        this.props.onTrafficVolumeChange(value);
    };
}
